import { sanitizeHTML } from '../../utils/safe-html';
import { Drawer, Button } from "antd";
import { useEffect, useState } from "react";

const EventsContentReview = ({ events, open, type, onClose }) => {

    const [title, setTitle] = useState('');

    useEffect(() => {
        if (events) {
            let ele = document.getElementById(`ai_events_cnt_${events.id}`);
            if (ele) {
                ele.innerHTML = '';
                let content = document.createElement('div');
                let summary = events.summary;
                if (!summary) return;
                summary = JSON.parse(summary);
                if (type === 1) {
                    content.innerHTML = sanitizeHTML(summary.article_body);
                    setTitle(summary.article_title);
                } else if (type === 2) {
                    content.innerHTML = sanitizeHTML(summary.notification_body);
                    setTitle(summary.notification_title);
                }
                let scripts = content.querySelectorAll('script');
                scripts.forEach((ele) => ele.remove());
                ele.appendChild(content);
            }
        }
    }, [events, type])

    if (!events) return <div />;

    return (
        <div>
            <Drawer
                key={events.id}
                forceRender={true}
                title={`Events ${type === 1 ? 'Summary' : 'Notification'} Review`}
                width={480}
                maskClosable
                onClose={onClose}
                open={open}
                extra={
                    <Button onClick={onClose}>Close</Button>
                }>
                <h1>{title}</h1>
                <div id={`ai_events_cnt_${events.id}`} />
            </Drawer>
        </div>
    )
}

export default EventsContentReview;